import React from 'react';
import { Grid } from 'semantic-ui-react';

import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import { equipmentsActions } from '../../../../behavior/equipments/index';
import { inforEamUrlSuffix } from '../../../../constants';
import InforEamTagsUrlInputWrapper from '../../../common/InforEamTagsUrlInputWrapper';
import { connect } from 'react-redux';

type Props = {
  values: any;
  errors: any;
  setFieldValue: (arg1: string, arg2: string) => void;
  equipmentAssetList: any[];
  equipmentPositionList: any[];
  disabled: boolean;
};

const IEquipmentContainer = ({
  values,
  errors,
  setFieldValue,
  equipmentAssetList,
  equipmentPositionList,
  disabled,
}: Props) => {
  const getEquipmentContainerContent = () => {
    return (
      <Grid stackable columns={2} verticalAlign="bottom">
        <GridColumnInputWrapper
          name="asset"
          label="inventory.details.page.equipment.container.asset.input"
          errors={errors}
          disabled={
            !disabled
              ? values.asset && !values.asset.equipmentCode && values.asset.position
              : disabled
          }
          render={(props: any) => (
            <InforEamTagsUrlInputWrapper
              {...props}
              inforEamUrlSuffix={inforEamUrlSuffix.ENV_ASSET}
              setFieldValue={setFieldValue}
              dynamicSuggestionListAction={(v: string) =>
                equipmentsActions.getAssetEquipmentAutocompleteList(v)
              }
              customFilteredSuggestions={equipmentAssetList}
              matchProperty="equipmentCode"
              displayProps="equipmentCode"
              value={values.asset}
              maxTags={1}
              onlyUnique
              clearInputCounter={0}
            />
          )}
        />
        <GridColumnInputWrapper
          name="asset"
          label="inventory.details.page.equipment.container.asset.position.input"
          disabled={
            !disabled
              ? values.asset && values.asset.equipmentCode && !values.asset.position
              : disabled
          }
          render={(props: any) => (
            <InforEamTagsUrlInputWrapper
              {...props}
              inforEamUrlSuffix={inforEamUrlSuffix.ENV_FUNCTIONAL_POSITION}
              setFieldValue={setFieldValue}
              dynamicSuggestionListAction={(v: string) =>
                equipmentsActions.getPositionEquipmentAutocompleteList(v)
              }
              customFilteredSuggestions={equipmentPositionList}
              matchProperty="position"
              displayProps="position"
              value={values.asset}
              maxTags={1}
              onlyUnique={true}
            />
          )}
        />
        <GridColumnInputWrapper
          width={16}
          name="equipmentDesc"
          render={() => <p>{values.asset && values.asset.equipmentdesc}</p>}
        />
      </Grid>
    );
  };

  const collapseEquipmentContainer =
    !values.asset || (!values.asset.equipmentCode && !values.asset.position);

  return (
    <AccordionWrapper
      collapsed={collapseEquipmentContainer}
      accordionTitle="inventory.details.page.equipment.container.title"
      render={getEquipmentContainerContent}
      className=""
    />
  );
};

const mapStateToProps = (state: any) => ({
  equipmentAssetList: state.equipments.equipmentAssetList,
  equipmentPositionList: state.equipments.equipmentPositionList,
});

export default connect(mapStateToProps)(IEquipmentContainer);
